require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.map");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.number.to-fixed");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.replace");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.regionalScreen = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var _default = {
    name: "RegionalScreen",
    data: function data() {
      return {
        ossHost: this.$config.base.ossHost,
        name: '鱼大大养殖终端大屏',
        time: '',
        date: '',
        day: '',
        weatherInfo: {},
        info: {
          totalKzqCount: 0,
          totalPoolAcreage: 0,
          totalPoolCount: 0,
          totalRyCount: 0,
          totalAdminCount: 0,
          yddIpcList: []
        },
        warningInfo: {
          oxyFormalCount: 0,
          lowDissolvedOxygenCount: 0,
          totalFormalCount: 0,
          totalOnlineCount: 0,
          warnCount: 0
        },
        duration: 3000,
        pondInfo: {
          lowOxygenCount: 0,
          powerList: [],
          serverOpenTimes: 0,
          timingOpenTimes: 0,
          ryLineView: {
            oxygen: 0,
            temperature: 0
          },
          poolName: '',
          no2_NView: [],
          nh3_NView: []
        },
        // 视频列表
        videoList: [],
        loading: true,
        pondList: [],
        isPhProbe: false,
        showEmptyOxygenBox: false,
        showEmptyPowerBox: false
      };
    },
    created: function created() {
      var vm = this;
      vm.refreshTime();
      vm.loadWarningInfo(); // 默认展示收个鱼塘

      vm.pondIndex = 0;
      vm.loadPoolList();
      vm.loadScreenInfo();
      setInterval(vm.refreshTime, 1000);
      setInterval(vm.loadWarningInfo, 30000);

      window.onresize = function () {
        window.location.reload();
      };
    },
    methods: {
      refreshTime: function refreshTime() {
        var vm = this;
        var t = new Date();
        var hours = t.getHours() > 9 ? t.getHours() : "0".concat(t.getHours());
        var min = t.getMinutes() > 9 ? t.getMinutes() : "0".concat(t.getMinutes());
        var seconds = t.getSeconds() > 9 ? t.getSeconds() : "0".concat(t.getSeconds());
        var month = t.getMonth() + 1 > 9 ? t.getMonth() + 1 : "0".concat(t.getMonth() + 1);
        var day = t.getDay();
        var date = t.getDate() > 9 ? t.getDate() : "0".concat(t.getDate());
        var weekDay = '星期一';

        switch (day) {
          case 2:
            weekDay = '星期二';
            break;

          case 3:
            weekDay = '星期三';
            break;

          case 4:
            weekDay = '星期四';
            break;

          case 5:
            weekDay = '星期五';
            break;

          case 6:
            weekDay = '星期六';
            break;

          case 7:
            weekDay = '星期日';
            break;

          default:
            break;
        }

        vm.time = "".concat(hours, ":").concat(min, ":").concat(seconds);
        vm.date = "".concat(month, "-").concat(date);
        vm.day = weekDay;
      },
      // 获取大屏首页相关信息
      loadScreenInfo: function loadScreenInfo() {
        var vm = this;
        var id = vm.$route.params.id;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/user/screen/userSecreen"),
          params: {
            encodeId: id
          },
          except: true
        }).then(function (res) {
          if (!res.data) {
            return;
          }

          !res.data.yddIpcList && (res.data.yddIpcList = []);
          vm.info = res.data;
          vm.loadWeatherInfo();
          setTimeout(vm.initCountChart, 400);
          setTimeout(vm.nextTick, 1000);
        });
      },
      // 获取在线数据
      loadWarningInfo: function loadWarningInfo() {
        var vm = this;
        var id = vm.$route.params.id;
        console.log(id);
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/user/screen/deviceStatus"),
          params: {
            encodeId: id
          },
          except: true
        }).then(function (res) {
          if (!res.data) {
            return;
          }

          for (var key in res.data) {
            var val = res.data[key]; // res.data[key] = val + Number((Math.random() * 5).toFixed(0))

            res.data[key] = val;
          }

          vm.warningInfo = res.data;
        });
      },
      // 获取用户列表
      loadPoolList: function loadPoolList() {
        var vm = this;
        var id = vm.$route.params.id;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/user/screen/poolList"),
          params: {
            encodeId: id
          },
          except: true
        }).then(function (res) {
          if (!res.data) {
            return;
          }

          console.log(res);
          vm.pondList = res.data; // 当前选中鱼塘

          vm.selectItem = vm.pondList[0];
          vm.loadPondInfo(vm.selectItem.poolId);
        });
      },
      initCountChart: function initCountChart() {
        var vm = this;

        try {
          document.getElementById('canvas-count-box') && document.getElementById('canvas-count-box').setAttribute('_echarts_instance_', '');
          var myChart = vm.$echarts.init(document.getElementById('canvas-count-box'));
          myChart.setOption({
            series: [{
              name: '',
              // 设置图表类型为饼图
              type: 'pie',
              // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
              radius: '68%',
              // 数据数组，name 为数据项名称，value 为数据项值
              data: [{
                value: vm.info.totalKzqCount,
                name: '控制器'
              }, {
                value: vm.info.totalRyCount,
                name: '溶氧仪'
              }],
              color: ['#898BFE', '#8CFFE9'],
              label: {
                textStyle: {
                  fontSize: 20,
                  color: '#fff'
                }
              }
            }]
          });
        } catch (error) {
          console.log(error);
        }
      },
      // 获取天气信息
      loadWeatherInfo: function loadWeatherInfo() {
        var vm = this;
        var _vm$info = vm.info,
            country = _vm$info.country,
            city = _vm$info.city;

        if (!city) {
          city = '上海市';
        }

        country && (country = country.replace('区', '').replace('县', ''));
        country == '徐汇' && (country = '徐家汇');
        city && (city = city.replace('市', '').replace('自治区', ''));
        var url = "https://api.seniverse.com/v3/weather/now.json?key=ukylf9xsedndf66m&location=".concat(city, "&language=zh-Hans&unit=c");
        vm.$http({
          type: "get",
          url: url,
          except: true
        }).then(function (res) {
          console.log(res);
          vm.weatherInfo = res.results[0].now;
        });
      },
      // 获取鱼塘信息
      loadPondInfo: function loadPondInfo(poolId) {
        var vm = this;
        var id = vm.$route.params.id;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/user/screen/poolInfo"),
          params: {
            encodeId: id,
            poolId: poolId
          },
          except: true
        }).then(function (res) {
          if (!res.data) {
            return;
          }

          vm.pondInfo = res.data; // 是否为荧光法数据

          vm.isPhProbe = res.data.sensorType == 3;
          setTimeout(function () {
            vm.renderPowerChart(res.data);
            vm.renderRyChart(res.data);
            vm.loadAndInitNO2Chart(res.data.no2_NView);
            vm.loadAndInitNH3NChart(res.data.nh3_NView); // 循环获取其他鱼塘数据展示出来，15秒切换一个鱼塘

            vm.pondList.length > 1 && setTimeout(function () {
              vm.pondIndex++;

              if (vm.pondIndex >= vm.pondList.length) {
                vm.pondIndex = 0;
              }

              vm.selectItem = vm.pondList[vm.pondIndex];
              vm.loadPondInfo(vm.selectItem.poolId);
            }, 20000);
          }, 200);
        });
      },
      // initSwiperEvent() {
      //     const vm = this
      //     const { carouselInfoViews } = vm.userInfo
      //     vm.swiperIntervalId && clearInterval(vm.swiperIntervalId);
      //     vm.pondTabIndex = 0;
      //     vm.swiperIntervalId = setInterval(() => {
      //         vm.pondTabIndex += 1
      //         if (vm.pondTabIndex == carouselInfoViews.length) {
      //             vm.pondTabIndex = 0
      //             vm.swiperIntervalId && clearInterval(vm.swiperIntervalId);
      //         }
      //     }, 7000)
      // },
      // 更新电流曲线
      renderPowerChart: function renderPowerChart(data) {
        var vm = this;

        try {
          var powerList = data.powerList;
          var xArr = [];
          var yArr = []; // const eleId = `power-chart-box${index}`

          var eleId = "power-chart-box";
          var maxVal = 0;
          document.getElementById(eleId) && document.getElementById(eleId).setAttribute('_echarts_instance_', '');
          var myChart = vm.$echarts.init(document.getElementById(eleId));
          var grid = {
            left: '15%',
            right: '5%',
            bottom: '20%',
            top: '5%'
          };
          var tooltip = {
            trigger: 'axis',
            show: false,
            position: function position(pt) {
              return [pt[0], '10%'];
            }
          };
          var xAxis = {
            type: 'category',
            // boundaryGap: false,
            data: xArr,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 20
              }
            }
          };
          powerList.length && powerList.map(function (item) {
            xArr.push("".concat(item.timeTag).substr(4, 6));
            item.kwh = parseInt(item.kwh / 100); // yArr.push(item.kwh || Math.random() * 1000)
            // if (!item.kwh) {
            //     const date = new Date().getDate();
            //     item.kwh = date * Math.random() * 10000
            // }

            yArr.push(item.kwh);
            item.kwh > maxVal && (maxVal = item.kwh + 200);
          });
          vm.showEmptyPowerBox = !maxVal;

          if (!maxVal) {
            myChart.clear();
            return;
          }

          var yAxis = {
            type: 'value',
            boundaryGap: [0, '100%'],
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 20
              },
              interval: maxVal / 2
            },
            min: 0,
            interval: maxVal / 2,
            max: maxVal
          };
          myChart.setOption({
            grid: grid,
            tooltip: tooltip,
            xAxis: xAxis,
            yAxis: yAxis,
            series: [{
              name: '月度用电量',
              type: 'bar',
              data: yArr,
              color: ['#898BFE'],
              barWidth: '20%'
            }]
          });
        } catch (error) {
          console.log(error);
        }
      },
      // 更新溶氧曲线
      renderRyChart: function renderRyChart(data) {
        var vm = this;

        try {
          var ryLineView = data.ryLineView;
          var xArr = [],
              yOxygenArr = [],
              yTempArr = [],
              phArr = [],
              textArr = []; // const oxygenId = `ry-chart-box${index}`;

          var oxygenId = "ry-chart-box"; // const tempId = `temp-chart-box${index}`;

          var tempId = "temp-chart-box";
          var phId = 'ph-chart-box';
          document.getElementById(oxygenId) && document.getElementById(oxygenId).setAttribute('_echarts_instance_', '');
          document.getElementById(tempId) && document.getElementById(tempId).setAttribute('_echarts_instance_', '');
          var oxygenChart = vm.$echarts.init(document.getElementById(oxygenId));
          var tempChart = vm.$echarts.init(document.getElementById(tempId));
          var phChart = '';
          var thereDayBefore = new Date().getTime() - 72 * 3600 * 1000; // 判断当前是否为PH探头

          if (vm.isPhProbe) {
            document.getElementById(phId) && document.getElementById(phId).setAttribute('_echarts_instance_', '');
            phChart = vm.$echarts.init(document.getElementById(phId));
          }

          if (!ryLineView.data[0]) {
            oxygenChart.clear();
            tempChart.clear();
            vm.isPhProbe && phChart.clear();
            vm.showEmptyOxygenBox = true;
            return;
          }

          vm.showEmptyOxygenBox = false;

          if (new Date(ryLineView.data[0].time * 1000).getTime() - thereDayBefore > 1200 * 1000) {
            ryLineView.data.unshift({
              oxygen: '-',
              temperature: '-',
              time: thereDayBefore / 1000,
              ph: '-'
            });
          }

          if (new Date(ryLineView.data[ryLineView.data.length - 1].time * 1000).getTime() - vm.$time.getUnixTime() < 1200 * 1000) {
            ryLineView.data.push({
              oxygen: '-',
              temperature: '-',
              time: vm.$time.getUnixTime() / 1000,
              ph: '-'
            });
          } // 对空的点进行数据处理


          ryLineView.data.map(function (item, index_) {
            var xText = "".concat(new Date(item.time * 1000).getMonth() + 1, "/").concat(new Date(item.time * 1000).getDate());
            var count = ryLineView.data[index_ + 1] && Math.abs(ryLineView.data[index_ + 1].time - item.time) / 1200;

            if (new Date(item.time * 1000).getTime() < thereDayBefore) {
              return;
            }

            !xArr.includes(xText) && textArr.push(xText); // 相邻的两个点超过20分就按照20分钟一个点进行补位

            if (count > 1) {
              xArr.push(xText);
              yOxygenArr.push(0);
              yTempArr.push(0);
              phArr.push(0);

              for (var j = 1; j < count; j++) {
                xArr.push(xText);
                yOxygenArr.push(0);
                yTempArr.push(0);
                phArr.push(0);
              }
            } else {
              xArr.push(xText);
              yOxygenArr.push(item.oxygen > 0 ? Number(item.oxygen.toFixed(1)) : 0);
              yTempArr.push(item.temperature > 0 ? Number(item.temperature.toFixed(1)) : 0);
              phArr.push(item.ph > 0 ? Number(item.ph.toFixed(1)) : 0);
            }
          });
          var grid = {
            left: '12%',
            right: '5%',
            bottom: '20%',
            top: '5%'
          };
          var tooltip = {
            trigger: 'axis',
            show: false,
            position: function position(pt) {
              return [pt[0], '10%'];
            }
          };
          var yAxis = {
            type: 'value',
            boundaryGap: [0, '100%'],
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 20
              }
            },
            min: 0,
            // interval: 10,
            splitNumber: 2
          };
          var phYAxis = {
            type: 'value',
            boundaryGap: [0, '100%'],
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 20
              }
            },
            min: 0,
            // interval: 10,
            splitNumber: 2,
            max: 10
          };
          var xAxis = {
            type: 'category',
            boundaryGap: false,
            data: xArr,
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 20
              },
              interval: Math.ceil(xArr.length / (textArr.length - 1)) - 2
            }
          };
          console.log(textArr); // ryLineView.data.length && ryLineView.data.map(item => {
          //     xArr.push(`${new Date(item.time * 1000).getMonth() + 1}/${new Date(item.time * 1000).getDate()}`)
          //     yOxygenArr.push(item.oxygen)
          //     yTempArr.push(item.temperature)
          // })

          var areaStyle = {
            color: new vm.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(99, 236, 255, 50)'
            }, {
              offset: 1,
              color: 'rgba(99, 236, 255, 0)'
            }])
          };
          oxygenChart.setOption({
            grid: grid,
            tooltip: tooltip,
            xAxis: xAxis,
            yAxis: yAxis,
            series: [{
              name: '溶氧',
              type: 'line',
              data: yOxygenArr,
              symbol: 'none',
              sampling: 'lttb',
              itemStyle: {
                color: 'rgb(99, 236, 255, 0)'
              },
              areaStyle: areaStyle
            }]
          });
          tempChart.setOption({
            grid: grid,
            tooltip: tooltip,
            xAxis: xAxis,
            yAxis: Object.assign(yAxis),
            series: [{
              name: '温度',
              type: 'line',
              data: yTempArr,
              symbol: 'none',
              sampling: 'lttb',
              itemStyle: {
                color: 'rgb(241,190,105, 0)'
              },
              areaStyle: areaStyle
            }]
          }); // ph探头曲线render

          vm.isPhProbe && phChart.setOption({
            grid: grid,
            tooltip: tooltip,
            xAxis: xAxis,
            yAxis: phYAxis,
            series: [{
              name: 'pH',
              type: 'line',
              data: phArr,
              symbol: 'none',
              sampling: 'lttb',
              itemStyle: {
                color: 'rgb(241,190,105, 0)'
              },
              areaStyle: areaStyle
            }]
          });
        } catch (error) {
          console.log(error);
        }
      },
      // 获取并加载氨氮曲线
      loadAndInitNH3NChart: function loadAndInitNH3NChart(data) {
        var vm = this;
        var xArr = [],
            yArr = [],
            xCount = 0;
        document.getElementById('NH3-N-chart') && document.getElementById('NH3-N-chart').setAttribute('_echarts_instance_', '');
        data.map(function (item) {
          var xText = "".concat(new Date(item.checkTime).getMonth() + 1, "/").concat(new Date(item.checkTime).getDate());
          !xArr.includes(xText) && xCount++;
          xArr.push(xText);
          yArr.push(item.checkValue / 100);
        });
        var nh3nChart = vm.$echarts.init(document.getElementById('NH3-N-chart'));

        if (!data.length) {
          nh3nChart.clear();
          return;
        }

        var grid = {
          left: '12%',
          right: '5%',
          bottom: '20%',
          top: '5%'
        };
        var tooltip = {
          trigger: 'axis',
          show: false,
          position: function position(pt) {
            return [pt[0], '10%'];
          }
        };
        var yAxis = {
          type: 'value',
          boundaryGap: [0, '100%'],
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 20
            }
          },
          min: 0,
          // interval: 10,
          splitNumber: 2
        };
        var xAxis = {
          type: 'category',
          boundaryGap: false,
          data: xArr,
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 20
            },
            interval: Math.ceil(xArr.length / (xCount - 1)) - 2
          }
        };
        nh3nChart.setOption({
          grid: grid,
          tooltip: tooltip,
          xAxis: xAxis,
          yAxis: Object.assign(yAxis),
          series: [{
            name: '氨氮',
            type: 'line',
            data: yArr,
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: 'rgb(241,190,105, 0)'
            },
            areaStyle: {
              color: new vm.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(149,69,255, 50)'
              }, {
                offset: 1,
                color: 'rgba(241,190,105, 0)'
              }])
            }
          }]
        });
      },
      // 获取并加载亚盐曲线
      loadAndInitNO2Chart: function loadAndInitNO2Chart(data) {
        var vm = this;
        var xArr = [],
            yArr = [],
            xCount = 0;
        document.getElementById('NO2-chart') && document.getElementById('NO2-chart').setAttribute('_echarts_instance_', '');
        data.map(function (item) {
          var xText = "".concat(new Date(item.checkTime).getMonth() + 1, "/").concat(new Date(item.checkTime).getDate());
          !xArr.includes(xText) && xCount++;
          xArr.push(xText);
          yArr.push(item.checkValue / 100);
        });
        var no2Chart = vm.$echarts.init(document.getElementById('NO2-chart'));

        if (!data.length) {
          no2Chart.clear();
          return;
        }

        var grid = {
          left: '12%',
          right: '5%',
          bottom: '20%',
          top: '5%'
        };
        var tooltip = {
          trigger: 'axis',
          show: false,
          position: function position(pt) {
            return [pt[0], '10%'];
          }
        };
        var yAxis = {
          type: 'value',
          boundaryGap: [0, '100%'],
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 20
            }
          },
          min: 0,
          // interval: 10,
          splitNumber: 2
        };
        var xAxis = {
          type: 'category',
          boundaryGap: false,
          data: xArr,
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 20
            },
            interval: Math.ceil(xArr.length / (xCount - 1)) - 2
          }
        };
        no2Chart.setOption({
          grid: grid,
          tooltip: tooltip,
          xAxis: xAxis,
          yAxis: Object.assign(yAxis),
          series: [{
            name: '亚盐',
            type: 'line',
            data: yArr,
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: 'rgb(241,190,105, 0)'
            },
            areaStyle: {
              color: new vm.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(149,69,255, 50)'
              }, {
                offset: 1,
                color: 'rgba(241,190,105, 0)'
              }])
            }
          }]
        });
      },
      nextTick: function nextTick() {
        var vm = this; // 处理摄像头列表

        vm.$nextTick(function () {
          var video0 = document.getElementById('video-0');
          var video1 = document.getElementById('video-1');
          var video2 = document.getElementById('video-2');
          var video3 = document.getElementById('video-3');
          var videoArr = [];
          video0 && videoArr.push(video0);
          video1 && videoArr.push(video1);
          video2 && videoArr.push(video2);
          video3 && videoArr.push(video3); // eslint-disable-next-line

          Player.init(videoArr);
          setTimeout(function () {
            // eslint-disable-next-line
            video0 && Player.ConnectDevice(video0.getAttribute('data-ipc-id'), '', 'admin', '', 0, 80, 0, 0, 1); // eslint-disable-next-line

            video1 && Player.ConnectDevice(video1.getAttribute('data-ipc-id'), '', 'admin', '', 1, 80, 0, 0, 1); // eslint-disable-next-line

            video2 && Player.ConnectDevice(video2.getAttribute('data-ipc-id'), '', 'admin', '', 2, 80, 0, 0, 1); // eslint-disable-next-line

            video3 && Player.ConnectDevice(video3.getAttribute('data-ipc-id'), '', 'admin', '', 3, 80, 0, 0, 1);
          }, 300);

          try {
            // eslint-disable-next-line
            window.console.log = function (msg) {
              console.info(msg);

              if (msg && msg.toLocaleString().includes('登录成功')) {
                // eslint-disable-next-line
                video0 && Player.OpenStream(video0.getAttribute('data-ipc-id'), '', 0, 1, 0); // 打开音频
                // eslint-disable-next-line

                video0 && Player.OpenAudio(0); // eslint-disable-next-line

                video1 && Player.OpenStream(video1.getAttribute('data-ipc-id'), '', 0, 1, 1); // eslint-disable-next-line

                video2 && Player.OpenStream(video2.getAttribute('data-ipc-id'), '', 0, 1, 1); // eslint-disable-next-line

                video3 && Player.OpenStream(video3.getAttribute('data-ipc-id'), '', 0, 1, 1);
              }
            };
          } catch (err) {
            console.log(err);
          }
        });
      },
      openDoc: function openDoc() {
        window.open(this.info.docUrl, '_blank');
      }
    }
  };
  _exports.default = _default;
});